import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import _ from "lodash";

class FilterModal extends Component {
  state = {
    searchText: "",
  };

  render() {
    const { filterModalData, catagory, filterModalDataCounts, modalType } = this.props;
    return (
      <Modal
        className={"modal fade salvex-modal"}
        dialogClassName="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered"
        show={this.props.showModal}
        onHide={(e) => {
          this.props.toggleModal();
          this.setState({ searchText: "" });
        }}
        centered
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {this.props.modalType === "catagory"
                ? "Category"
                : this.props.modalType === "catagory1"
                ? "Sub Category"
                : this.props.modalType === "make"
                ? "Manufacturer"
                : this.props.modalType === "model"
                ? "Model"
                : "Region"}
            </h5>
            <div className="searchInput">
              <input
                type="text"
                placeholder="Search"
                className="form-control"
                value={this.state.searchText}
                onChange={(e) => {
                  const value = e.target.value;
                  this.setState({ searchText: value });
                }}
              />
            </div>
            <div
              className="close-btn"
              data-bs-dismiss="modal"
              onClick={(e) => {
                this.props.toggleModal();
                this.setState({ searchText: "" });
              }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>
          <div className="modal-body">
            {filterModalData && filterModalData.length > 0 && catagory && (
              <ul className="three-column-row">
                {filterModalData
                  .sort(function (a, b) {
                    var textA = a.toUpperCase();
                    var textB = b.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                  })
                  .filter((v) => v.toLowerCase().includes(this.state.searchText.toLowerCase()))
                  .sort((a, b) => filterModalDataCounts[b] - filterModalDataCounts[a])
                  .map((v) => {
                    return (
                      <li className="tcr-item">
                        <div className="form-check d-flex align-items-center">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id={v}
                            checked={catagory.find((ev) => ev === v) ? true : false}
                          />
                          <label
                            className="form-check-label"
                            for={v}
                            onClick={() => {
                              this.props.setData(modalType, v);
                            }}
                          >
                            {this.props.modalType === "catagory1"
                              ? `${v.substr(v.indexOf(">") + 1)} (${filterModalDataCounts[v]})`
                              : `${v} (${filterModalDataCounts[v]})`}
                          </label>
                        </div>
                      </li>
                    );
                  })}
              </ul>
            )}
          </div>
          <div className="modal-footer">
            <a
              href="javascript:void(0)"
              className="btn btn-black-text"
              data-bs-dismiss="modal"
              onClick={(e) => {
                e.preventDefault();
                this.props.clearFilter(modalType);
              }}
            >
              Clear
            </a>
            <a
              href="javascript:void(0)"
              className="btn btn-default btn-sm"
              onClick={(e) => {
                e.preventDefault();
                this.props.toggleModal();
              }}
            >
              Apply
            </a>
          </div>
        </div>
      </Modal>
    );
  }
}

export default FilterModal;
